import { AfterViewChecked, AfterViewInit, Component, ElementRef, OnInit, SecurityContext, ViewChild } from '@angular/core';
import { LeftSideNavComponent } from '../../../shared/layout/app/left-menu/left-side-nav.component';
import { HeaderComponent } from '../../../shared/layout/app/header/header.component';
import { DigitalCatalogueBllService } from '../digital-catalogue-bll.service';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { ParamsToGetProductsList, ProductDetailsResponseModel, ProductListResponseModel, ProductMediaGroup, ContactMeDataModel } from '../digital-catalogue.model';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { UserEventStatusRespModel } from '../../profile/profile.model';
import { BaseResponse } from '../../../shared/models/base-response.model';
import { ProfileBllService } from '../../profile/profile-bll.service';
import { UserService } from '../../../core/services/user.service';
import { LoaderService } from '../../../shared/components/loader/loader.service';
import { InterestSharePopupComponent } from '../../../shared/components/interest-share-popup/interest-share-popup.component';
import { InterestSharedSuccessPopupComponent } from '../../../shared/components/interest-shared-success-popup/interest-shared-success-popup.component';
import { DeviceTypeService } from '../../../core/services/device-type.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { VirtualEventBllService } from '../../virtual-event/virtual-event-bll.service';
import { HomeBllService } from '../../home/home-bll.service';
import { EventDetailsResponseModel } from '../../home/home.model';
declare var bootstrap: any;


@Component({
  selector: 'app-catalogue-product-details',
  imports: [LeftSideNavComponent, HeaderComponent, CommonModule, InterestSharePopupComponent, InterestSharedSuccessPopupComponent, RouterLink],
  templateUrl: './catalogue-product-details.component.html',
  styleUrls: ['./catalogue-product-details.component.scss'],
  providers: [CurrencyPipe]
})
export class CatalogueProductDetailsComponent implements OnInit, AfterViewInit, AfterViewChecked {

  productId: string = ''; // Encoded product ID from route
  productDetails: ProductDetailsResponseModel | null = null; // Product details data
  productMedia: ProductMediaGroup['product_media'] = []; // Media assets for the product
  brochureList: ProductMediaGroup['product_brochures'] = [];
  productList: ProductListResponseModel['list'] = [];
  pavilionCode: string = '';
  currency: string | undefined;
  formattedPrice: string | null = null;
  isLoadingMore: boolean = false;


  paramsToFetchData: ParamsToGetProductsList = {
    skip_product_id: 0,
    company_id: 0
  };

  readonly limit = 130;
  isExpanded = false;
  isLongText = false;

  truncatedContent!: SafeHtml;
  fullContent!: SafeHtml;

  /**
   * User profile data
   */
  userProfile: UserEventStatusRespModel["user_profile"] | null = null;
  @ViewChild('carousel', { static: false }) carouselRef!: ElementRef;
  private carouselInstance: any;

  /** Interest share popup component reference */
  @ViewChild('interestSharedPopup') interestSharedPopup!: InterestSharePopupComponent;
  contactData: ContactMeDataModel = {
    brandName: '',
    productTitle: '',
    companyLogoUrl: '',
    userImageUrl: '',
    color: ''
  }

  // variable to hold do not show message again checkbox value
  doNotShowMessage: boolean = false;

  // variable to hold activity code
  activity_code: string = '';

  // variable to hold the source of user(android_web/ios_web/web)
  source: string = "";

  // variable to check whether the product is liked or not
  liked: boolean = false;

  // variable to show success message on shortlist
  successMsg: boolean = false;

  // variable to hold success message text
  successText: string = '';

  // variable to check whether user has registered as virtual visitor
  hasRegisteredAsVirtualVisitor: boolean = false;
  eventDetails: EventDetailsResponseModel | null = null;

  @ViewChild('successModal') successModal!: InterestSharedSuccessPopupComponent;

  constructor(
    private catalogueBllService: DigitalCatalogueBllService,
    private route: ActivatedRoute,
    private router: Router,
    private profileBll: ProfileBllService,
    private userService: UserService,
    private loader: LoaderService,
    private currencyPipe: CurrencyPipe,
    private deviceService: DeviceTypeService,
    private sanitizer: DomSanitizer,
    private virtualBll: VirtualEventBllService,
    private homeBll: HomeBllService,
  ) { }

  ngOnInit(): void {
    // Subscribe to route parameters to get the product ID
    this.route.paramMap.subscribe(params => {
      const productId = params.get('product_id');

      if (productId) {
        this.loadProductDetails(productId);
      }
    });

    // Get the source of user
    this.source = this.deviceService.getUserSource();

    const pavilionDetails = this.catalogueBllService.getSelectedPavilionDetails();
    if (pavilionDetails) {
      this.pavilionCode = pavilionDetails.pavilionCode || '';
     
    }

    this.fetchUserEventStatus();
    this.loadEventDetails();
  }

  ngAfterViewInit(): void {
    // Initialize the carousel first time
    this.initializeCarousel();
  }

  ngAfterViewChecked(): void {
    // If productMedia changes, reinitialize
    if (this.productMedia?.length && !this.carouselInstance) {
      this.initializeCarousel();
    }
  }

  private initializeCarousel(): void {
    setTimeout(() => {
      const carouselEl = this.carouselRef?.nativeElement;
      if (carouselEl) {
        // Dispose any old instance
        const existing = bootstrap.Carousel.getInstance(carouselEl);
        if (existing) existing.dispose();

        // Create a new one
        this.carouselInstance = new bootstrap.Carousel(carouselEl, {
          interval: 3000,
          ride: 'carousel',
          pause: 'hover',
          wrap: true
        });
      }
    });
  }


  /**
   * @description Fetches the user's event status and updates the user profile and service accordingly.
   */
  fetchUserEventStatus() {
    this.profileBll
      .submitGetUserEventStatus()
      .then((res: BaseResponse<UserEventStatusRespModel>) => {
        this.userProfile = res.data.user_profile;
        if (this.userProfile) {
          const previewLogo =
            this.userProfile.image_url ??
            "/assets/images/Default-profile-photo.png";
          const userName = `${this.userProfile.first_name} ${this.userProfile.last_name}`;
          this.userService.setUser({
            name: userName,
            profileImg: previewLogo,
            mobile: this.userProfile.mobile,
            state: this.userProfile.state,
            city: this.userProfile.city,
            hasUnassignedTickets: res.data.event_my_tickets.unassigned_tickets_bought_by_me > 0,
            hasAssignedTickets: res.data.event_my_tickets.assigned_tickets_bought_by_me > 0 || res.data.event_my_tickets.tickets_assigned_for_me > 0,
          });
           this.doNotShowMessage = res.data.user_profile?.do_not_show_message || false;
        }

        /**
         * @description Check if the user is an event attendee and register as a virtual visitor if true.
         */
        const attendee = res?.data?.event_my_tickets?.event_attendee_details;
        if (!attendee) {
          this.registerVirtualVisitor();
        }
        
      })
      .catch((error) => {
        console.error("Error fetching user event status:", error);
      })
  }

  /**
   * Load product details by product ID
   * @param productId The ID of the product to load
   */
  loadProductDetails(productId: string): void {
    // Call the BLL service to fetch product details
    this.loader.show();
    this.catalogueBllService.fetchProductDetails(productId)
      .then((res) => {
        this.productDetails = res.data;
        this.productMedia = this.productDetails?.media.product_media || [];
        this.brochureList = this.productDetails?.media.product_brochures || [];
        this.currency = this.productDetails?.currency;
        const locale = this.currency === 'INR' ? 'en-IN' : 'en-US';
        this.formattedPrice = this.currencyPipe.transform(this.productDetails?.price, this.currency, '', '1.0-2', locale);
        this.paramsToFetchData.skip_product_id = this.productDetails?.id;
        this.paramsToFetchData.company_id = this.productDetails?.user_id;
        this.liked = this.productDetails?.liked || false;
        this.processDescription(this.productDetails.desc_english || '');
        this.loadCompanyProducts(this.paramsToFetchData);
      })
      .catch((error) => {
        console.error('Error fetching product details:', error);
        this.router.navigate(['/catalogue/products-list'], {
          queryParams: { pavilion_code: this.pavilionCode }
        });
      })
      .finally(() => {
        this.loader.hide();
      });
  }

  private processDescription(html: string): void {
    // Remove unsafe HTML content
    const sanitizedHtml = this.sanitizer.sanitize(SecurityContext.HTML, html) || '';
    const plainText = this.stripHtml(sanitizedHtml);
    if (plainText.length > this.limit) {
      this.isLongText = true;
      const truncatedText = plainText.substring(0, this.limit) + '...';
      this.truncatedContent = this.sanitizer.bypassSecurityTrustHtml(`<span>${truncatedText}</span>`);
      this.fullContent = this.sanitizer.bypassSecurityTrustHtml(sanitizedHtml);
    } else {
      this.isLongText = false;
      this.truncatedContent = this.sanitizer.bypassSecurityTrustHtml(sanitizedHtml);
    }
  }

  loadCompanyProducts(params: ParamsToGetProductsList): void {
    this.isLoadingMore = true;

    this.catalogueBllService.fetchProductList(params)
      .then((res) => {
        this.productList = res.data.list;
        this.isLoadingMore = false;
      })
      .catch((error) => {
        this.isLoadingMore = false;
      });
  }

  openMedia(url: string): void {
    window.open(url, '_blank');
  }

  /**
   * Handle back button click
   */
  onClickBack(): void {
   setTimeout(() => this.scrollToTop(), 0);
   window.history.back();
  }

  /**
   * On click recommended product redirect to product details page
   * @param productId 
   */
  viewProductDetails(productId: string | null): void {
    setTimeout(() => this.scrollToTop(), 0);
    this.router.navigate(
      ['/catalogue/product-details', productId]
    );
  }

  /**
   * On click company name or arrow redirect to company details page
   * @param company_id 
   */
  viewCompanyDetails(companyId: number): void {
    // Navigate to the company details page with encoded ID
    const encodedId = btoa(companyId.toString()); // encode as Base64
    this.router.navigate(["/catalogue/company-details"], {
      queryParams: {
        id: encodedId,
        userId: companyId
      },
    });
  }

  toggleReadMore(event: Event): void {
    event.preventDefault();
    this.isExpanded = !this.isExpanded;
  }

  private stripHtml(html: string): string {
    const safeHtml = this.sanitizer.sanitize(SecurityContext.HTML, html) || '';
    return safeHtml.replace(/<[^>]*>/g, '');
  }

  /**
   * @description Opens the interest share popup or directly submits user activity based on the doNotShowMessage flag.
   */
  openModel(): void {
    if (this.doNotShowMessage) {
      this.activity_code = 'interested_in_product';
      this.callsubmitUserActivity();
    } else {
      this.openInterestSharePopup();
    }
  }

  /**
   * @description Opens the interest share popup.
   */
  openInterestSharePopup(): void {
    if (!this.productDetails) return;

    const contactData: ContactMeDataModel = {
      brandName: this.productDetails.brandname,
      productTitle: this.productDetails.title_english,
      companyLogoUrl: this.productDetails.image_bigthumb_url,
      userImageUrl: this.userProfile?.image_url ?? "/assets/images/Default-profile-photo.png",
      color: this.productDetails.image_max_color || '#008940'
    };
    this.loader.hide();
    this.interestSharedPopup.show(contactData);
  }

  /**
   * 
   * @param isChecked Whether the "Do not show message again" checkbox is checked
   */
  onDoNotShowChange(isChecked: boolean) {
    this.doNotShowMessage = isChecked;
  }

  /**
   * @description Handles the confirmation action from the interest share popup.
   */
  onConfirmPopup() {
    this.activity_code = 'interested_in_product';
    this.callsubmitUserActivity();
  }

  /**
   * @description Handles the cancellation action from the interest share popup.
   */
  onCancelPopup() {
    this.doNotShowMessage = false;
    this.interestSharedPopup.resetDoNotShowCheckbox();
  }

  /**
   * @description Submits user activity indicating interest in a product.
   * @returns void
   */
  callsubmitUserActivity(): void {
    this.loader.show();
    if (!this.productDetails) return;

    const activityRequest = {
      activity_code: this.activity_code,
      activity_for_item_id: this.productDetails.id,
      activity_for_user_type: "exhibitor",
      activity_by_user_type: "visitor",
      activity_for_userid: this.productDetails.user_id,
      for: 'product',
      source: this.source,
      do_not_show_message: this.doNotShowMessage
    };

    this.catalogueBllService.submitUserActivity(activityRequest)
      .then((res) => {
        this.loader.hide(); // Hide loader
        
        if (this.activity_code === 'like_product') {
          this.liked = !this.liked;
          this.successText = this.catalogueBllService.getShortListMessage(this.liked);
          this.successMsg = true;
          setTimeout(() => {
            this.successMsg = false;
          }, 3000);
        }

        if (this.activity_code === 'interested_in_product') {
          this.interestSharedPopup.hide(); // Hide interest share popup       
          this.successModal.show(this.productDetails?.image_max_color || '#008940', 'product'); // Show success modal

          setTimeout(() => {
            this.successModal.hide(); // Hide after 5 seconds
          }, 5000);
        }

      }).catch((err) => {
        this.loader.hide();
        console.log(err)
      })
  }

  /**
   * @description Scrolls the window to the top smoothly.
   */
  private scrollToTop(): void {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  shortlistProduct(): void {
    this.activity_code = 'like_product';
    this.callsubmitUserActivity();
  }

  viewShortlist(): void {
    this.router.navigate(['/catalogue/product-wishlist']);
  }

  get successGradientBackground(): string {
    const color = this.productDetails?.image_max_color;

    // If productDetails OR the color is missing → return default gradient
    if (!color) {
      return this.catalogueBllService.getLinearGradient();
    }

    // Otherwise return gradient with actual color
    return this.catalogueBllService.getLinearGradient(color);
  }

  goToTicketPage(){
    this.router.navigate(["reg/select-ticket"]);
  }

  registerVirtualVisitor() {
    this.virtualBll.submitRegisterVirtualVisitor().then(() => {
      // Registration successful
      this.hasRegisteredAsVirtualVisitor = true;
    }).catch(() => {
      // Registration failed or already registered
      // We can choose to ignore errors here
      this.hasRegisteredAsVirtualVisitor = false;
    });
  }

  loadEventDetails() {
    this.homeBll.fetchEventDetails()
      .then((response) => {
        this.eventDetails = response.data;      
      
         this.userService.setLeftMenu({
          allow_to_register: this.eventDetails.allow_to_register,
          show_digital_catalog: this.eventDetails.show_digital_catalog,
          event_status: this.eventDetails.event_status
        });
        
      })
      .catch((error) => {
        console.error('Error fetching event details:', error);
      });
  }

}
